class BrandDirectoryFilter extends HTMLElement {
  constructor() {
    super();

    this.designHouses = window.designHouses;

    if (!this.designHouses) {
      return;
    }

    this.gender = '.';
    this.letter = '.';

    this.brandsTitle = this.querySelector('[data-item-title]');
    this.brandsContainer = this.querySelector('[data-item-list]');

    this.letters = this.querySelectorAll('.shop-brand__letter button');
    this.genders = this.querySelectorAll('.shop-brand__sidebar button');

    this.letters.forEach((letter) => {
      letter.addEventListener('click', () => {
        if (letter.getAttribute('rel') == this.letter) {
          letter.setAttribute('aria-current', 'false');
          this.letter = '.';
        } else {
          const selected = this.querySelector(
            '.shop-brand__letter [aria-current="true"]'
          );

          if (selected) {
            selected.setAttribute('aria-current', 'false');
          }

          this.letter = letter.getAttribute('rel');
          letter.setAttribute('aria-current', 'true');
        }

        this.update();
      });
    });

    this.genders.forEach((gender) => {
      gender.addEventListener('click', () => {
        if (gender.getAttribute('rel') == this.gender) {
          gender.setAttribute('aria-current', 'false');
          this.gender = '.';
        } else {
          const selected = this.querySelector(
            '.shop-brand__sidebar [aria-current="true"]'
          );

          if (selected) {
            selected.setAttribute('aria-current', 'false');
          }

          this.gender = gender.getAttribute('rel');
          gender.setAttribute('aria-current', 'true');
        }

        this.update();
      });
    });

    this.update();
  }

  update() {
    this.brandsContainer.innerHTML = '';

    if (this.gender == '.') {
      this.brandsTitle.innerHTML =
        this.brandsTitle.getAttribute('data-item-title');
    } else if (this.gender == 'W') {
      this.brandsTitle.innerHTML = 'All Perfume Brands';
    } else if (this.gender == 'M') {
      this.brandsTitle.innerHTML = 'All Cologne Brands';
    }

    this.designHouses.forEach((house) => {
      if (this.letter != '.' && this.letter != house.c) {
        return;
      }

      if (this.gender == '.' || house[this.gender] == '1') {
        const li = document.createElement('li');
        li.classList.add('shop-brand__item');

        const a = document.createElement('a');
        a.classList.add('link');
        a.classList.add('full-unstyled-link');
        a.classList.add('body');
        a.href = `/collections/${house.h}`;
        a.innerHTML = `${house.name}`;

        li.appendChild(a);

        this.brandsContainer.appendChild(li);
      }
    });
  }
}

customElements.define('brand-directory', BrandDirectoryFilter);
